const TIMEOUT = 1000;

/**
 *  Returns a promise containing the coordinates of the current location
 *  The coordinates object looks like { latitude, longitude }
 */
export default function fetchCurrentLocation() {
    return new Promise((resolve, reject) => {
        if (typeof navigator === 'undefined' || !('geolocation' in navigator)) { reject(new Error('geolocation api is not enabled')); }

        navigator.geolocation.getCurrentPosition(
            position => resolve(position.coords),
            err => reject(err),
            { timeout: TIMEOUT }
        );
    });
}
